import React, { useEffect, useState } from 'react';
import NavLogo from '../../../components/NavLogo';
import { useNavigate, useParams } from 'react-router-dom';
import Logo from '../../../components/Logo';
import { useDispatch, useSelector } from 'react-redux';
import {
  approveTradePaymentReset,
  approve_trade_payment_for_offer_on_bid,
  confirmTradeByContractNumberReset,
  confirm_trade_by_contract_number_for_offer_on_bid,
  getEntityProfileList,
  retrieveSpecificBrokerOfferReset,
  retrieve_specific_broker_sub_offer_details,
  uploadSignedTradeContractReset,
  uploadTradeProofOfPaymentReset,
  upload_signed_trade_contract,
  upload_trade_proof_of_payment,
} from '../../../utils/actions';
import * as app_consts from '../../../utils/constants';
import ChildHeaderBanner from '../../../layouts/ChildHeaderBanner';
import CustomTabs from '../../../layouts/CustomTabs';
import { format, parseISO } from 'date-fns';
import AdvancedDocumentViewer from '../../../layouts/AdvancedDocumentViewer';
import YesNoModal from '../../../components/modals/YesNoModal';
import ImageDocUploadModal from '../../../components/modals/ImageDocUploadModal';
import { convertToTitleCase } from '../../../utils/functionalUtils';
import UpdateBidModal from '../../../components/modals/UpdateBidModal';

const SubOfferDetails = () => {
  const { entity_id, entity_mid, broker_offer_id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [profilesList, setProfilesList] = useState([]);
  const [activeTab, setActiveTab] = useState('Bid Details');
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [trade_data, setTradeData] = useState([]);
  const [broker_bid_data, setBrokerBidData] = useState([]);
  const [broker_offer_data, setBrokerOfferData] = useState([]);
  const [buyer_data, SetBuyerData] = useState();
  const [seller_bank_data, setSellerBankData] = useState([]);
  const [seller_data, setSellerData] = useState([]);
  const [contract_data, setContractData] = useState([]);
  const [downloadTradingInvoice, setDownloadTradingInvoice] = useState(false);
  const [downloadTradingContract, setDownloadTradingContract] = useState(false);

  // Yes No Modal For Upload Proof Of Payment
  const [openPaymentYesNoModal, setOpenPaymentYesNoModal] = useState(false);
  const [openPaymentYesNoModalAction, setOpenPaymentYesNoModalAction] =
    useState('');
  const [openPaymentYesNoModalLoading, setOpenPaymentYesNoModalLoading] =
    useState('');
  const [openPaymentYesNoModalError, setOpenPaymentYesNoModalError] =
    useState('');

  // Yes No Modal For Signed Trade Contract
  const [
    openSignedTradeContractYesNoModal,
    setOpenSignedTradeContractYesNoModal,
  ] = useState(false);
  const [
    openSignedTradeContractYesNoModalLoading,
    setOpenSignedTradeContractYesNoModalLoading,
  ] = useState('');
  const [
    openSignedTradeContractYesNoModalError,
    setOpenSignedTradeContractYesNoModalError,
  ] = useState('');

     // Yes or NO Modal For Confirming Trade
  const [openTradeConfirmationYesNoModal, setOpenTradeConfirmationYesNoModal] = useState(false);
  const [openTradeConfirmationYesNoModalLoading, setOpenTradeConfirmationYesNoModalLoading] = useState("");
  const [openTradeConfirmationYesNoModalError, setOpenTradeConfirmationYesNoModalError] = useState("");
  
  // Document Upload Modal
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [uploadDocName, setUploadDocName] = useState('');
  const [selectedDocName, setSelectedDocName] = useState();
  const [uploadError, setUploadError] = useState('');
  const [uploadLoading, setUploadLoading] = useState(false);

  const [dropdownVisible, setDropdownVisible] = useState(false);

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const [modal, setModal] = useState({
    tradingAuthorityModal: false,
  });

  const closeTradingAuthorityModal = () => {
    setModal({ ...modal, tradingAuthorityModal: false });
  };

  const openSelectedModal = (modalToBeOpened) => {
    setModal({ ...modal, [modalToBeOpened]: true });
  };

  const openUploadModal = () => {
    setIsUploadModalOpen(true);
    setUploadDocName(selectedDocName);
  };

  const openUploadContractModal = () => {
    setOpenSignedTradeContractYesNoModal(true);
    if (activeTab === 'Contract Details') {
      setSelectedDocName('Contract');
    }
  };

  const closeUploadModal = () => {
    setIsUploadModalOpen(false);
    setUploadDocName('');
  };

  const openSignedTradeContractModalOpenFunction = () => {
    setOpenSignedTradeContractYesNoModal(true);
    setOpenSignedTradeContractYesNoModalError('');
  };

  const openSignedTradeContractModalCloseFunction = () => {
    setOpenSignedTradeContractYesNoModal(false);
    setOpenSignedTradeContractYesNoModalError('');
  };

  // Initial UseEffect to Run When Page Opens
  useEffect(() => {
    fetchProfileList();
    dispatch(retrieve_specific_broker_sub_offer_details(broker_offer_id));
  }, []);

  // Fetech Profile List
  const fetchProfileList = async () => {
    try {
      dispatch(getEntityProfileList(entity_id));
    } catch (error) {
      console.error(error);
    }
  };

  // Retrieve Profile List from State
  const profile_list = useSelector((state) => state.entityProfilesList);

  useEffect(() => {
    if (profile_list.data) {
      const selectedlist = profile_list.data?.find(
        (profile) => profile.member_type_id === entity_mid
      );
      setProfilesList(selectedlist);
    }
  }, [profile_list]);
  // Listen to Specific Broker Offer Reducer
  const specific_broker_offer = useSelector(
    (state) => state.retrieveSpecificBrokerOffer
  );

  useEffect(() => {
    if (specific_broker_offer.status !== app_consts.IDLE) {
      if (specific_broker_offer.isLoading) {
        setLoading(true);
      } else {
        setLoading(false);
        if (specific_broker_offer.error) {
          setError(specific_broker_offer.error);
        } else {
          setTradeData(specific_broker_offer?.data?.trade);
          setBrokerBidData(specific_broker_offer?.data?.broker_bid);
          setBrokerOfferData(specific_broker_offer?.data?.broker_offer);
          SetBuyerData(specific_broker_offer?.data?.buyer);
          setSellerBankData(specific_broker_offer?.data?.seller_bank_account);
          setSellerData(specific_broker_offer?.data?.seller);
          setContractData(specific_broker_offer?.data?.contract);
          setIsDataFetched(true);
        }
        dispatch(retrieveSpecificBrokerOfferReset());
      }
    }
  }, [specific_broker_offer]);

  const tabs = [
    { title: 'Bid Details', disabled: !isDataFetched },
    { title: 'Offer Details', disabled: !isDataFetched },
    { title: 'Invoice and Payment', disabled: !isDataFetched },
    { title: 'Contract Details', disabled: !isDataFetched },
  ];

  // Open Yes No Modal Function
  const openPaymentYesNoModalOpenFunction = () => {
    setOpenPaymentYesNoModal(true);
    setOpenPaymentYesNoModalError('');
    if (activeTab === 'Invoice and Payment') {
      setSelectedDocName('Proof of Payment');
    }
  };

   // Open Confirm Trade Modal
   const openConfirmTradeModal = () => {
    setOpenTradeConfirmationYesNoModal(true);
    setOpenTradeConfirmationYesNoModalError("");
};

  const openPaymentYesNoModalCloseFunction = () => {
    setOpenPaymentYesNoModal(false);
    setOpenPaymentYesNoModalError('');
  };

  
  const openTradeConfirmationModalCloseFunction = () => {
      setOpenTradeConfirmationYesNoModal(false);
      setOpenTradeConfirmationYesNoModalError("");
  };
  // Confirm Trade Agree Function
  const confirmTradeAgreeFunction = () => {
      setOpenTradeConfirmationYesNoModalError("");
      dispatch(confirm_trade_by_contract_number_for_offer_on_bid({ contract_reference_no: contract_data?.contract_reference_no }));
  };

  const agreeFuncYesNoModal = () => {
    // Dispatch to Approve
    setOpenPaymentYesNoModalError("");
    dispatch(approve_trade_payment_for_offer_on_bid(trade_data?.trade_id));
  };

  const uploadDocumentFunction = (image_file) => {
    setUploadError('');
    if (activeTab === 'Invoice and Payment') {
      dispatch(
        upload_trade_proof_of_payment({
          trade_id: trade_data?.trade_id,
          trade_proof_of_payment: image_file,
        })
      );
    } else if (activeTab === 'Contract Details') {
      dispatch(
        upload_signed_trade_contract({
          contract_id: contract_data?.contract_id,
          upload_document: image_file,
          upload_type: 'seller',
        })
      );
    }
  };

  // Open Upload Modal
  const agreeFuncSignedTradeContractModal = () => {
    openSignedTradeContractModalCloseFunction();
    openUploadModal();
  };

  // Upload State Listeners
  const uploadTradeProofOfPayment = useSelector(
    (state) => state.uploadTradeProofOfPayment
  );

  useEffect(() => {
    if (uploadTradeProofOfPayment.status !== app_consts.IDLE) {
      if (uploadTradeProofOfPayment.isLoading) {
        setUploadLoading(true);
      } else {
        setUploadLoading(false);
        if (uploadTradeProofOfPayment.error) {
          setUploadError(uploadTradeProofOfPayment.error);
        } else {
          dispatch(retrieve_specific_broker_sub_offer_details(broker_offer_id));
          closeUploadModal();
        }
        dispatch(uploadTradeProofOfPaymentReset());
      }
    }
  }, [uploadTradeProofOfPayment]);

  // Upload State Listeners
  const uploadSignedTradeContract = useSelector(
    (state) => state.uploadSignedTradeContract
  );

  useEffect(() => {
    if (uploadSignedTradeContract.status !== app_consts.IDLE) {
      if (uploadSignedTradeContract.isLoading) {
        setUploadLoading(true);
      } else {
        setUploadLoading(false);
        if (uploadSignedTradeContract.error) {
          setUploadError(uploadSignedTradeContract.error);
        } else {
          dispatch(retrieve_specific_broker_sub_offer_details(broker_offer_id));
          closeUploadModal();
        }
        dispatch(uploadSignedTradeContractReset());
      }
    }
  }, [uploadSignedTradeContract]);

  const approve_trade_payment_listenser = useSelector((state) => state.approveTradePayment);
  // 
  useEffect(() => {
    if (approve_trade_payment_listenser.status !== app_consts.IDLE) {
      if (approve_trade_payment_listenser.isLoading) {
        setOpenPaymentYesNoModalLoading(true);
      } else {
        setOpenPaymentYesNoModalLoading(false);
        if (approve_trade_payment_listenser.error) {
          setOpenPaymentYesNoModalError(approve_trade_payment_listenser.error);
        } else {
          // Close Modal and Refresh Page
          openPaymentYesNoModalCloseFunction();
          dispatch(retrieve_specific_broker_sub_offer_details(broker_offer_id));

        }
        dispatch(approveTradePaymentReset());
      }
    }
  }, [approve_trade_payment_listenser]);

    // Reducer To Confirm Trade
      const confirm_trade_listenser = useSelector((state) => state.confirmTradeByContractNumber);
      // 
      useEffect(() => {
          if (confirm_trade_listenser.status !== app_consts.IDLE) {
              if (confirm_trade_listenser.isLoading) {
                  setOpenTradeConfirmationYesNoModalLoading(true);
              } else {
                  setOpenTradeConfirmationYesNoModalLoading(false);
                  if (confirm_trade_listenser.error) {
                      setOpenTradeConfirmationYesNoModalError(confirm_trade_listenser.error);
                  } else {
                      // Close Modal and Refresh Page
                      openTradeConfirmationModalCloseFunction();
                      dispatch(retrieve_specific_broker_sub_offer_details(broker_offer_id));
                    }
                  dispatch(confirmTradeByContractNumberReset());
              }
          }
      }, [confirm_trade_listenser]);
  
  // Handle Logout
  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };
  return (
    <>
      <div>
        <button
          data-drawer-target='logo-sidebar'
          data-drawer-toggle='logo-sidebar'
          aria-controls='logo-sidebar'
          type='button'
          className='inline-flex items-center p-2 mt-2 ml-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600'
        >
          <span className='sr-only'>Open sidebar</span>
          <svg
            className='w-6 h-6'
            aria-hidden='true'
            fill='currentColor'
            viewBox='0 0 20 20'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              clip-rule='evenodd'
              fill-rule='evenodd'
              d='M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z'
            ></path>
          </svg>
          <NavLogo />
        </button>

        <aside
          id='logo-sidebar'
          className='fixed top-0 left-0 z-40 w-64 h-screen transition-transform -translate-x-full sm:translate-x-0'
          aria-label='Sidebar'
        >
          <div className='h-full px-3 py-4 overflow-y-auto bg-gray-50 dark:bg-gray-800'>
            <a href='/' className='flex items-center pl-2.5 mb-5'>
              <Logo />
            </a>

            <ul className='space-y-2 font-medium'>
              <li>
                <a
                  href='/home'
                  className='flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'
                >
                  <svg
                    class='w-6 h-6  dark:text-white'
                    aria-hidden='true'
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 18 18'
                  >
                    <path
                      stroke='currentColor'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      stroke-width='2'
                      d='M6.143 1H1.857A.857.857 0 0 0 1 1.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 7 6.143V1.857A.857.857 0 0 0 6.143 1Zm10 0h-4.286a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 17 6.143V1.857A.857.857 0 0 0 16.143 1Zm-10 10H1.857a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 7 16.143v-4.286A.857.857 0 0 0 6.143 11Zm10 0h-4.286a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286a.857.857 0 0 0 .857-.857v-4.286a.857.857 0 0 0-.857-.857Z'
                    />
                  </svg>
                  <span className='ml-3'>My Dashboards</span>
                </a>
              </li>
              <li>
                <a
                  href={`/broker/${entity_id}/${entity_mid}`}
                  className='flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke='currentColor'
                    className='w-6 h-6'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6'
                    />
                  </svg>
                  <span className='ml-3'>Broker Dashboard</span>
                </a>
              </li>
              <li>
                <a
                  href={`/broker/${entity_id}/${entity_mid}/customer_management`}
                  className='flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke-width='1.5'
                    stroke='currentColor'
                    class='w-6 h-6'
                  >
                    <path
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      d='M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z'
                    />
                  </svg>
                  <span className='ml-3'>Clients</span>
                </a>
              </li>
              <li>
                <a
                  href={`/broker/${entity_id}/${entity_mid}/bid_management`}
                  className='flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke-width='1.5'
                    stroke='currentColor'
                    class='w-6 h-6'
                  >
                    <path
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      d='M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z'
                    />
                  </svg>
                  <span className='ml-3'>Bids</span>
                </a>
              </li>
              <li>
                <a
                  href={`/broker/${entity_id}/${entity_mid}/offer_management`}
                  className='flex items-center p-2 text-green-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke-width='1.5'
                    stroke='currentColor'
                    class='w-6 h-6'
                  >
                    <path
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      d='M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m.75 12l3 3m0 0l3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z'
                    />
                  </svg>
                  <span className='ml-3'>Offers</span>
                </a>
              </li>
              <li>
                <a
                  href={`/broker/${entity_id}/${entity_mid}/live_market`}
                  className='flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke-width='1.5'
                    stroke='currentColor'
                    class='w-6 h-6'
                  >
                    <path
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      d='M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z'
                    />
                  </svg>
                  <span className='ml-3'>ATS</span>
                </a>
              </li>
              <li>
                <a className='cursor-not-allowed flex items-center p-2 text-gray-400 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'>
                  <svg
                    class='w-6 h-6 dark:text-white'
                    aria-hidden='true'
                    viewBox='0 0 20 18'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M6.5 8C5.80777 8 5.13108 7.79473 4.55551 7.41015C3.97993 7.02556 3.53133 6.47893 3.26642 5.83939C3.00152 5.19985 2.9322 4.49612 3.06725 3.81719C3.2023 3.13825 3.53564 2.51461 4.02513 2.02513C4.51461 1.53564 5.13825 1.2023 5.81719 1.06725C6.49612 0.932205 7.19985 1.00152 7.83939 1.26642C8.47893 1.53133 9.02556 1.97993 9.41015 2.55551C9.79473 3.13108 10 3.80777 10 4.5'
                      stroke='currentColor'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <path
                      d='M6.5 17H1V15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11'
                      stroke='currentColor'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <path
                      d='M19.5 11H18.38C18.2672 10.5081 18.0714 10.0391 17.801 9.613L18.601 8.818C18.6947 8.72424 18.7474 8.59708 18.7474 8.4645C18.7474 8.33192 18.6947 8.20476 18.601 8.111L17.894 7.404C17.8002 7.31026 17.6731 7.25761 17.5405 7.25761C17.4079 7.25761 17.2808 7.31026 17.187 7.404L16.392 8.204C15.9647 7.93136 15.4939 7.73384 15 7.62V6.5C15 6.36739 14.9473 6.24021 14.8536 6.14645C14.7598 6.05268 14.6326 6 14.5 6H13.5C13.3674 6 13.2402 6.05268 13.1464 6.14645C13.0527 6.24021 13 6.36739 13 6.5V7.62C12.5081 7.73283 12.0391 7.92863 11.613 8.199L10.818 7.404C10.7242 7.31026 10.5971 7.25761 10.4645 7.25761C10.3319 7.25761 10.2048 7.31026 10.111 7.404L9.404 8.111C9.31026 8.20476 9.25761 8.33192 9.25761 8.4645C9.25761 8.59708 9.31026 8.72424 9.404 8.818L10.204 9.618C9.9324 10.0422 9.73492 10.5096 9.62 11H8.5C8.36739 11 8.24021 11.0527 8.14645 11.1464C8.05268 11.2402 8 11.3674 8 11.5V12.5C8 12.6326 8.05268 12.7598 8.14645 12.8536C8.24021 12.9473 8.36739 13 8.5 13H9.62C9.73283 13.4919 9.92863 13.9609 10.199 14.387L9.404 15.182C9.31026 15.2758 9.25761 15.4029 9.25761 15.5355C9.25761 15.6681 9.31026 15.7952 9.404 15.889L10.111 16.596C10.2048 16.6897 10.3319 16.7424 10.4645 16.7424C10.5971 16.7424 10.7242 16.6897 10.818 16.596L11.618 15.796C12.0422 16.0676 12.5096 16.2651 13 16.38V17.5C13 17.6326 13.0527 17.7598 13.1464 17.8536C13.2402 17.9473 13.3674 18 13.5 18H14.5C14.6326 18 14.7598 17.9473 14.8536 17.8536C14.9473 17.7598 15 17.6326 15 17.5V16.38C15.4919 16.2672 15.9609 16.0714 16.387 15.801L17.182 16.601C17.2758 16.6947 17.4029 16.7474 17.5355 16.7474C17.6681 16.7474 17.7952 16.6947 17.889 16.601L18.596 15.894C18.6897 15.8002 18.7424 15.6731 18.7424 15.5405C18.7424 15.4079 18.6897 15.2808 18.596 15.187L17.796 14.392C18.0686 13.9647 18.2662 13.4939 18.38 13H19.5C19.6326 13 19.7598 12.9473 19.8536 12.8536C19.9473 12.7598 20 12.6326 20 12.5V11.5C20 11.3674 19.9473 11.2402 19.8536 11.1464C19.7598 11.0527 19.6326 11 19.5 11ZM14 14.5C13.5055 14.5 13.0222 14.3534 12.6111 14.0787C12.2 13.804 11.8795 13.4135 11.6903 12.9567C11.5011 12.4999 11.4516 11.9972 11.548 11.5123C11.6445 11.0273 11.8826 10.5819 12.2322 10.2322C12.5819 9.8826 13.0273 9.6445 13.5123 9.54804C13.9972 9.45157 14.4999 9.50108 14.9567 9.6903C15.4135 9.87952 15.804 10.2 16.0787 10.6111C16.3534 11.0222 16.5 11.5055 16.5 12C16.5 12.663 16.2366 13.2989 15.7678 13.7678C15.2989 14.2366 14.663 14.5 14 14.5Z'
                      fill='currentColor'
                    />
                  </svg>

                  <span className='flex-1 ml-3 whitespace-nowrap'>
                    My Profile
                  </span>
                </a>
              </li>
              <li className='my-2 fixed bottom-12 w-11/12'>
                <a
                  onClick={handleLogout}
                  className='cursor-pointer flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'
                >
                  <svg
                    class='w-6 h-6 dark:text-white'
                    aria-hidden='true'
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 16 16'
                  >
                    <path
                      stroke='currentColor'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      stroke-width='2'
                      d='M4 8h11m0 0-4-4m4 4-4 4m-5 3H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3'
                    />
                  </svg>
                  <span className='flex-1 ml-3 whitespace-nowrap'>
                    Sign Out
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </aside>

        <div className='p-4 sm:ml-64'>
          <div className='p-4 rounded-lg dark:border-gray-700'>
            <ChildHeaderBanner
              title='Offer Details'
              header_addition={
                profilesList && profilesList.entity_name
                  ? profilesList.entity_name
                  : ''
              }
              type={app_consts.BID_DETAILS}
              navInfo={{ entity_id, entity_mid, broker_offer_id }}
              home={`home`}
            />
            <div className='relative'>
              <CustomTabs
                tabs={tabs}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
              />
              <br />
              {loading ? (
                <>
                  <div className='text-center mt-4 h-10'>
                    <div role='status'>
                      <svg
                        aria-hidden='true'
                        className='inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-green-600'
                        viewBox='0 0 100 101'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
                          fill='currentColor'
                        />
                        <path
                          d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
                          fill='currentFill'
                        />
                      </svg>
                      <span className='sr-only'>Please wait...</span>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {error && error?.length > 0 ? (
                    <>
                      <div className='text-center mt-8 h-10'>
                        <div
                          role='status'
                          className='text-red-600 flex flex-col items-center justify-center mb-4 leading-4'
                        >
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            fill='none'
                            viewBox='0 0 24 24'
                            strokeWidth={1.5}
                            stroke='currentColor'
                            className='w-8 h-8'
                          >
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              d='M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                            />
                          </svg>
                        </div>
                        <span
                          colSpan='8'
                          className='text-gray-700 py-4 my-6 tracking-wider'
                        >
                          Could Not Retrieve Bid Details.
                        </span>
                      </div>
                    </>
                  ) : (
                    <>
                      {activeTab === 'Bid Details' && (
                        <>
                          <div>
                            <div class='flex flex-col items-stretch justify-end flex-shrink-0 w-full space-y-2 md:w-auto md:flex-row md:space-y-0 md:items-center md:space-x-3'>
                              <button
                                type='button'
                                // onClick={openModal}
                                onClick={() =>
                                  setModal({ tradingAuthorityModal: true })
                                }
                                className='flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-lg bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800'
                              >
                                <svg
                                  xmlns='http://www.w3.org/2000/svg'
                                  viewBox='0 0 20 20'
                                  fill='currentColor'
                                  className='w-5 h-5 mr-2'
                                >
                                  <path d='M5.433 13.917l1.262-3.155A4 4 0 017.58 9.42l6.92-6.918a2.121 2.121 0 013 3l-6.92 6.918c-.383.383-.84.685-1.343.886l-3.154 1.262a.5.5 0 01-.65-.65z' />
                                  <path d='M3.5 5.75c0-.69.56-1.25 1.25-1.25H10A.75.75 0 0010 3H4.75A2.75 2.75 0 002 5.75v9.5A2.75 2.75 0 004.75 18h9.5A2.75 2.75 0 0017 15.25V10a.75.75 0 00-1.5 0v5.25c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-9.5z' />
                                </svg>
                                Update Bid
                              </button>
                              <div className='flex items-center w-full space-x-3 md:w-auto relative'>
                                <button
                                  id='actionsDropdownButton'
                                  onClick={toggleDropdown}
                                  className='flex items-center justify-center w-full px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700'
                                  type='button'
                                >
                                  <svg
                                    className='-ml-1 mr-1.5 w-5 h-5'
                                    fill='currentColor'
                                    viewBox='0 0 20 20'
                                    xmlns='http://www.w3.org/2000/svg'
                                    aria-hidden='true'
                                  >
                                    <path
                                      clipRule='evenodd'
                                      fillRule='evenodd'
                                      d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'
                                    />
                                  </svg>
                                  Actions
                                </button>
                                {dropdownVisible && (
                                  <div className='absolute top-full right-0 mt-1 z-10 bg-white divide-y divide-gray-100 rounded shadow w-44 dark:bg-gray-700 dark:divide-gray-600'>
                                    <ul className='py-1 text-sm text-gray-700 dark:text-gray-200'>
                                      <li>
                                        <a
                                          href='#'
                                          // onClick={handleExportCSV}
                                          className='block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white'
                                        >
                                          Withdraw Bid
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class='relative overflow-hidden bg-white dark:bg-gray-800 sm:rounded-lg'>
                              {broker_bid_data && (
                                <>
                                  <div class='flex-row items-center justify-between p-4 space-y-3 sm:flex sm:space-y-0 sm:space-x-4'>
                                    <div>
                                      <h5 class='mr-3 font-semibold dark:text-white'>
                                        Bid Details
                                      </h5>
                                      {/* <p class='text-gray-600 font-medium dark:text-gray-400'>
                                          Commodity Offer
                                        </p> */}
                                    </div>
                                  </div>
                                  <dl className='grid grid-cols-2 gap-4 mb-4'>
                                    <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                        Reference Number
                                      </dt>
                                      <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                        {broker_bid_data?.broker_bid_reference_no
                                          ? broker_bid_data?.broker_bid_reference_no
                                          : ''}
                                      </dd>
                                    </div>
                                    <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                        Date Submmited to Platform
                                      </dt>
                                      <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                        {broker_bid_data.date_submitted_to_platform
                                          ? format(
                                            parseISO(
                                              broker_bid_data.date_submitted_to_platform
                                            ),
                                            'yyyy-MM-dd HH:mm:ss'
                                          )
                                          : '-'}
                                      </dd>
                                    </div>
                                    <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                        Commodity
                                      </dt>
                                      <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                        {broker_bid_data.commodity
                                          ? broker_bid_data.commodity
                                          : '---'}
                                      </dd>
                                    </div>
                                    <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                        Quality
                                      </dt>
                                      <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                        {broker_bid_data.quality
                                          ? broker_bid_data.quality
                                          : '---'}
                                      </dd>
                                    </div>
                                    <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                        Requested Unit Price?
                                      </dt>
                                      <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                        {broker_bid_data.requested_unit_price
                                          ? `${broker_bid_data.requested_unit_price.toFixed(
                                            2
                                          )} ZMW`
                                          : '---'}
                                      </dd>
                                    </div>
                                    <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                        Bid Volume
                                      </dt>
                                      <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                        {broker_bid_data.bid_volume
                                          ? `${broker_bid_data.bid_volume.toFixed(
                                            2
                                          )} MT`
                                          : '---'}
                                      </dd>
                                    </div>
                                    <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                        Unit of Measure
                                      </dt>
                                      <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                        {broker_bid_data.unit_of_measure
                                          ? broker_bid_data.unit_of_measure
                                          : '---'}
                                      </dd>
                                    </div>
                                    <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                        Bid Amount
                                      </dt>
                                      <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                        {broker_bid_data.bid
                                          ? `${broker_bid_data.bid.toFixed(
                                            2
                                          )} MT`
                                          : '---'}
                                      </dd>
                                    </div>
                                    <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                        Bid Total
                                      </dt>
                                      <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                        {broker_bid_data.bid_total
                                          ? `${broker_bid_data.bid_total.toFixed(
                                            2
                                          )} ZMW`
                                          : '---'}
                                      </dd>
                                    </div>
                                    <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                        Status
                                      </dt>
                                      <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                        <span className='bg-yellow-100 text-yellow-800'>
                                          {broker_bid_data?.status
                                            ? broker_bid_data.status.toUpperCase()
                                            : '---'}
                                        </span>
                                      </dd>
                                    </div>
                                    <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                        Delivery
                                      </dt>
                                      <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                        {broker_bid_data.delivery
                                          ? broker_bid_data.delivery
                                          : '---'}
                                      </dd>
                                    </div>
                                    <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                        Location
                                      </dt>
                                      <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                        {broker_bid_data.location
                                          ? broker_bid_data.location
                                          : '---'}
                                      </dd>
                                    </div>
                                    <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                        Order Type
                                      </dt>
                                      <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                        {broker_bid_data.order_type
                                          ? broker_bid_data.order_type.toUpperCase()
                                          : '---'}
                                      </dd>
                                    </div>
                                  </dl>
                                </>
                              )}
                            </div>
                            <UpdateBidModal
                              showModal={modal.tradingAuthorityModal}
                              closeModal={closeTradingAuthorityModal}
                              openSelectedModal={openSelectedModal}
                              bidData={broker_bid_data}
                            />
                          </div>
                        </>
                      )}
                    </>
                  )}

                  {activeTab === 'Offer Details' && (
                    <>
                      <div>
                        <div class='relative overflow-hidden bg-white dark:bg-gray-800 sm:rounded-lg'>
                          {broker_offer_data && (
                            <>
                              <div class='flex-row items-center justify-between p-4 space-y-3 sm:flex sm:space-y-0 sm:space-x-4'>
                                <div>
                                  <h5 class='mr-3 font-semibold dark:text-white'>
                                    Offer Details
                                  </h5>
                                  {/* <p class='text-gray-600 font-medium dark:text-gray-400'>
                                              Commodity Offer
                                            </p> */}
                                </div>
                              </div>
                              <dl className='grid grid-cols-2 gap-4 mb-4'>
                                <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                  <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                    Reference Number
                                  </dt>
                                  <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                    {broker_offer_data?.commodity_order_reference_no
                                      ? broker_offer_data?.commodity_order_reference_no
                                      : ''}
                                  </dd>
                                </div>
                                <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                  <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                    Date Submmited to Platform
                                  </dt>
                                  <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                    {broker_offer_data?.date_submitted_to_platform
                                      ? format(
                                        parseISO(
                                          broker_offer_data?.date_submitted_to_platform
                                        ),
                                        'yyyy-MM-dd HH:mm:ss'
                                      )
                                      : '-'}
                                  </dd>
                                </div>
                                <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                  <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                    Commodity
                                  </dt>
                                  <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                    {broker_offer_data?.commodity
                                      ? broker_offer_data?.commodity
                                      : '---'}
                                  </dd>
                                </div>
                                <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                  <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                    Quality
                                  </dt>
                                  <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                    {broker_offer_data?.quality
                                      ? broker_offer_data?.quality
                                      : '---'}
                                  </dd>
                                </div>
                                <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                  <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                    Other Documentation Required
                                  </dt>
                                  <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                    {broker_offer_data?.other_documentation_required
                                      ? broker_offer_data?.other_documentation_required
                                      : '---'}
                                  </dd>
                                </div>
                                <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                  <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                    Special Terms and Conditions
                                  </dt>
                                  <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                    {broker_offer_data?.special_terms_and_conditions
                                      ? broker_offer_data?.special_terms_and_conditions
                                      : '---'}
                                  </dd>
                                </div>
                                <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                  <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                    Unit of Measure
                                  </dt>
                                  <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                    {broker_offer_data?.unit_of_measure
                                      ? broker_offer_data?.unit_of_measure
                                      : '---'}
                                  </dd>
                                </div>
                                <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                  <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                    Delivery
                                  </dt>
                                  <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                    {broker_offer_data?.delivery
                                      ? broker_offer_data?.delivery
                                      : '---'}
                                  </dd>
                                </div>
                                <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                  <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                    Location
                                  </dt>
                                  <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                    {broker_offer_data?.location
                                      ? broker_offer_data?.location
                                      : '---'}
                                  </dd>
                                </div>
                                <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                  <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                    Order Type
                                  </dt>
                                  <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                    {broker_offer_data?.order_type
                                      ? broker_offer_data?.order_type.toUpperCase()
                                      : '---'}
                                  </dd>
                                </div>
                              </dl>
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {activeTab === 'Invoice and Payment' && (
                    <>
                      <div>
                        <div class='relative overflow-hidden bg-white dark:bg-gray-800 sm:rounded-lg'>
                          {buyer_data ? (
                            <>
                              <div class='flex-row items-center justify-between p-4 space-y-3 sm:flex sm:space-y-0 sm:space-x-4'>
                                <div>
                                  <h5 class='mr-3 font-semibold dark:text-white'>
                                    Invoice and Payment
                                  </h5>
                                  {/* <p class='text-gray-600 font-medium dark:text-gray-400'>
                                                      Commodity Offer
                                                    </p> */}
                                </div>
                                {
                                  trade_data?.trade_payment_url && trade_data?.trade_payment_status === "pending" && (
                                    <>
                                      <div>

                                        <button
                                          type="button"
                                          onClick={() => setOpenPaymentYesNoModal(true)}
                                          className="flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-lg bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                            className="w-5 h-5 mr-2"
                                          >
                                            <path d="M5.433 13.917l1.262-3.155A4 4 0 017.58 9.42l6.92-6.918a2.121 2.121 0 013 3l-6.92 6.918c-.383.383-.84.685-1.343.886l-3.154 1.262a.5.5 0 01-.65-.65z" />
                                            <path d="M3.5 5.75c0-.69.56-1.25 1.25-1.25H10A.75.75 0 0010 3H4.75A2.75 2.75 0 002 5.75v9.5A2.75 2.75 0 004.75 18h9.5A2.75 2.75 0 0017 15.25V10a.75.75 0 00-1.5 0v5.25c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-9.5z" />
                                          </svg>
                                          Confirm Trade Payment
                                        </button>
                                      </div>
                                    </>
                                  )
                                }
                              </div>
                              <dl className='grid grid-cols-2 gap-4 mb-4'>
                                <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                  <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                    Trade Invoice Number
                                  </dt>
                                  <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                    {trade_data?.trade_invoice_number
                                      ? trade_data?.trade_invoice_number
                                      : ''}
                                  </dd>
                                </div>
                                <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                  <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                    Trade Payment Status
                                  </dt>
                                  <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                    <span className='bg-yellow-100 text-yellow-800'>
                                      {trade_data?.trade_payment_status
                                        ? trade_data?.trade_payment_status.toUpperCase()
                                        : ''}
                                    </span>
                                  </dd>
                                </div>
                              </dl>
                              <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mb-4'>
                                <AdvancedDocumentViewer
                                  name="Issued Invoice"
                                  downloadable={true}
                                  downloadClick={downloadTradingInvoice}
                                  setDownloadClick={setDownloadTradingInvoice}
                                  uploadButton={false}
                                  doc_type={app_consts.SYSTEM_INVOICE_GENERATED_PDF}
                                  data={{ buyer: buyer_data, trade_data: trade_data, broker_offer_data, broker_bid_data, seller_bank_data, seller: seller_data }}
                                // url={entity.entity_reg_cert_url}
                                />
                                <AdvancedDocumentViewer
                                  name='Proof Of Payment'
                                  // uploadButton={false}
                                  noDocumentMessage='Proof Of Payment has not Been Uploaded.'
                                  url={trade_data?.trade_payment_url}
                                // onEditClick={
                                //   openPaymentYesNoModalOpenFunction
                                // }
                                />
                              </div>
                            </>
                          ) : (
                            <>
                              <div className='text-center mt-8 h-auto'>
                                <div
                                  role='status'
                                  className='text-red-600 flex flex-col items-center justify-center mb-4 leading-4'
                                >
                                  <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    fill='none'
                                    viewBox='0 0 24 24'
                                    strokeWidth={1.5}
                                    stroke='currentColor'
                                    className='w-8 h-8'
                                  >
                                    <path
                                      strokeLinecap='round'
                                      strokeLinejoin='round'
                                      d='M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                                    />
                                  </svg>
                                </div>
                                <span
                                  colSpan='8'
                                  className='text-gray-700 py-4 my-6 tracking-wider'
                                >
                                  Invoice and Payment Can Only Be Viewed After
                                  Bid Has Been Accepted.
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {/* <YesNoModal
                        isOpen={openPaymentYesNoModal}
                        setIsOpen={setOpenPaymentYesNoModal}
                        closeFunction={openPaymentYesNoModalCloseFunction}
                        modalTitle={`Upload Proof Of Payment?`}
                        messageHint={`Please Make Sure that the Proof Of Payment Document about to be Uploaded is Correct and has the correct Credentials in corresspondence to Issued Invoice.`}
                        cancelButtonLabel='Cancel'
                        agreeButtonLabel='Continue'
                        agreeClickFunction={agreeFuncYesNoModal}
                        modalError={openPaymentYesNoModalError}
                        modalLoading={openPaymentYesNoModalLoading}
                        modalMessage={`Once Uploaded, Proof of Payment cannot be Re-Uploaded.`}
                      /> */}
                      <YesNoModal isOpen={openPaymentYesNoModal} setIsOpen={setOpenPaymentYesNoModal} closeFunction={openPaymentYesNoModalCloseFunction} modalTitle={`Approve Proof Of Payment?`} modalMessage={`Please Make Sure that the Proof Of Payment Document corresspondences to Issued Invoice.`} cancelButtonLabel="Cancel" agreeButtonLabel="Approve" agreeClickFunction={agreeFuncYesNoModal} modalError={openPaymentYesNoModalError} modalLoading={openPaymentYesNoModalLoading} messageHint={`Once Approved A Contract will Be Generated That Needs Both Signatures from the Buyer and the Seller for Trade Completion.`} />

                    </>
                  )}
                  {activeTab === 'Contract Details' && (
                    <>
                      <div>
                        <div class='relative overflow-hidden bg-white dark:bg-gray-800 sm:rounded-lg'>
                          {contract_data ? (
                            <>
                              <div class='flex-row items-center justify-between p-4 space-y-3 sm:flex sm:space-y-0 sm:space-x-4'>
                                <div>
                                  <h5 class='mr-3 font-semibold dark:text-white'>
                                    Contract Details
                                  </h5>
                                  {/* <p class='text-gray-600 font-medium dark:text-gray-400'>
                                                      Commodity Offer
                                                    </p> */}
                                </div>
                                {
                                  contract_data?.buyer_uploaded_contract === 1 && contract_data?.contract_img && contract_data?.status === "pending_confirmation" && (
                                    <>
                                      <div>

                                        <button
                                          type="button"
                                          onClick={() => openConfirmTradeModal()}
                                          className="flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-lg bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                            className="w-5 h-5 mr-2"
                                          >
                                            <path d="M5.433 13.917l1.262-3.155A4 4 0 017.58 9.42l6.92-6.918a2.121 2.121 0 013 3l-6.92 6.918c-.383.383-.84.685-1.343.886l-3.154 1.262a.5.5 0 01-.65-.65z" />
                                            <path d="M3.5 5.75c0-.69.56-1.25 1.25-1.25H10A.75.75 0 0010 3H4.75A2.75 2.75 0 002 5.75v9.5A2.75 2.75 0 004.75 18h9.5A2.75 2.75 0 0017 15.25V10a.75.75 0 00-1.5 0v5.25c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-9.5z" />
                                          </svg>
                                          Confirm Trade
                                        </button>
                                      </div>
                                    </>
                                  )
                                }
                              </div>
                              <dl className='grid grid-cols-2 gap-4 mb-4'>
                                <div className='col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600'>
                                  <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                                    Contract Reference Number
                                  </dt>
                                  <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                                    {contract_data?.contract_reference_no
                                      ? contract_data?.contract_reference_no
                                      : ''}
                                  </dd>
                                </div>
                                <div className="col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600">
                                  <dt className="mb-2 font-semibold leading-none text-gray-900 dark:text-white">Contract Status</dt>
                                  <dd className="flex items-center text-gray-500 dark:text-gray-400">
                                    <span className='bg-yellow-100 text-yellow-800'>{contract_data?.status ? convertToTitleCase(contract_data?.status.toUpperCase()) : ""}</span>
                                  </dd>
                                </div>
                              </dl>
                              {/* Check if Seller Has Uploaded Contract */}

                              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                {
                                  contract_data?.seller_uploaded_contract !== 1 && !contract_data?.contract_img && (
                                    <>
                                      <AdvancedDocumentViewer
                                        name="Issued Contract"
                                        uploadButton={false}
                                        downloadable={true}
                                        downloadClick={downloadTradingContract}
                                        setDownloadClick={setDownloadTradingContract}
                                        doc_type={app_consts.SYSTEM_CONTRACT_GENERATED_PDF}
                                        data={{ buyer_data, trade_data, trade_data, broker_offer_data, broker_bid_data, seller_bank_data, seller: seller_data, contract: contract_data, warehouse_receipt: "warehouse_receipt_data" }}
                                      />
                                    </>
                                  )
                                }
                                <AdvancedDocumentViewer
                                  name={contract_data?.buyer_uploaded_contract === 1 ? "Buyer Signed Contract" : "Seller Signed Contract"}
                                  uploadButton={!contract_data?.contract_img}
                                  url={contract_data?.contract_img}
                                  noDocumentMessage="Signed Contract has not Been Uploaded."
                                  onEditClick={openSignedTradeContractModalOpenFunction}
                                />

                              </div>

                            </>
                          ) : (
                            <>
                              <div className='text-center mt-8 h-auto'>
                                <div
                                  role='status'
                                  className='text-red-600 flex flex-col items-center justify-center mb-4 leading-4'
                                >
                                  <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    fill='none'
                                    viewBox='0 0 24 24'
                                    strokeWidth={1.5}
                                    stroke='currentColor'
                                    className='w-8 h-8'
                                  >
                                    <path
                                      strokeLinecap='round'
                                      strokeLinejoin='round'
                                      d='M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                                    />
                                  </svg>
                                </div>
                                <span
                                  colSpan='8'
                                  className='text-gray-700 py-4 my-6 tracking-wider'
                                >
                                  Contract Details Can Only Be Viewed After
                                  Payment Has Been Approved.
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <YesNoModal
        isOpen={openSignedTradeContractYesNoModal}
        setIsOpen={setOpenSignedTradeContractYesNoModal}
        closeFunction={openSignedTradeContractModalCloseFunction}
        modalTitle={`Upload Seller Signed Contract?`}
        modalMessage={`Please Make Sure that the Signed Trade Contract has been fully Signed on the Seller Part Only.`}
        cancelButtonLabel='Cancel'
        agreeButtonLabel='Upload'
        agreeClickFunction={agreeFuncSignedTradeContractModal}
        modalError={openSignedTradeContractYesNoModalError}
        modalLoading={openSignedTradeContractYesNoModalLoading}
        messageHint={`Once Uploaded, your signed Contract will be sent to the Buyer. Note: A Contract cannot be Re-uploaded.`}
      />
      <ImageDocUploadModal
        isOpen={isUploadModalOpen}
        docName={uploadDocName}
        uploadDocumentFunction={uploadDocumentFunction}
        closeUploadModal={closeUploadModal}
        uploadLabal={
          uploadLoading
            ? `Uploading ${uploadDocName}...`
            : `Upload ${uploadDocName}`
        }
        modalLoading={uploadLoading}
        modalError={uploadError}
      />
    <YesNoModal isOpen={openTradeConfirmationYesNoModal} setIsOpen={setOpenTradeConfirmationYesNoModal} closeFunction={openTradeConfirmationModalCloseFunction} modalTitle={`Confirm Trade`} modalMessage={`Please Confirm the Contract has been fully Signed by Both Parties.`} cancelButtonLabel="Cancel" agreeButtonLabel={openTradeConfirmationYesNoModalLoading ? `Confirming Trade ...` : `Confirm Trade`} agreeClickFunction={confirmTradeAgreeFunction} modalError={openTradeConfirmationYesNoModalError} modalLoading={openTradeConfirmationYesNoModalLoading} messageHint={`Once Confirmed, the Seller's Warehouse Receipt will be Split. The current Receipt will be Cancelled and the New Receipt will replace the cancelled one on the ATS if the New Quantity is not Zero. A Warehouse Receipt Will be Generated for the Buyer as well.`} />

    </>
  );
};

export default SubOfferDetails;
